import { render, staticRenderFns } from "./pvRoutineForm.vue?vue&type=template&id=188d98fa&scoped=true&"
import script from "./pvRoutineForm.vue?vue&type=script&lang=js&"
export * from "./pvRoutineForm.vue?vue&type=script&lang=js&"
import style0 from "./pvRoutineForm.vue?vue&type=style&index=0&id=188d98fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d98fa",
  null
  
)

export default component.exports